import { Component, Optional } from '@angular/core';

import { AuthService } from '../core/auth.service';
import { environment } from '../../environments/environment';
import { SessionService } from '../core/session.service';
import { ConsentService } from '../services/consent.service';
import { DialogRef } from '../components/dialog';

@Component({
  selector: 'app-profile-popup',
  templateUrl: './profile-popup.component.html',
  styleUrls: ['./profile-popup.component.scss'],
})
export class ProfilePopupComponent {
  public isDev = !environment.production;

  constructor(
    private authService: AuthService,
    private consent: ConsentService,
    public session: SessionService,
    @Optional() private dialogRef: DialogRef | null
  ) {}

  public async logout() {
    await this.authService.totalLogout().then();
  }

  public manageCookies(): void {
    // Reopen the consent banner, then close this popup. Done in order
    // (not via appDialogClose on the same click) so the banner is shown
    // by a deterministic sequence rather than relying on listener order.
    this.consent.reopen();
    this.dialogRef?.close();
  }
}
